import {useState} from "react";
import {Button, Icon} from "~/components";
import {Tooltip} from "antd";

function CreatedWebsiteAction({item, onClickPlus, onClickReInsert, setItemEdit, openModal}) {

	const [plusLoading, setPlusLoading] = useState(false);
	const [insertLoading, setInsertLoading] = useState(false);

	const buttonHandlers = {
		plus: async () => {
			setPlusLoading(true);
			await onClickPlus?.(item);
			setPlusLoading(false);
		},
		reInsert: async () => {
			setInsertLoading(true);
			await onClickReInsert?.(item);
			setInsertLoading(false);
		},
		edit: async () => {
			setItemEdit(item);
			openModal('edit')
		},
		restore: async () => {
			setItemEdit(item);
			openModal('restore')
		},
	};

	return (
		<div className="table-action d-flex">
			{(item.status === 0 && item.trash === 0) && <Tooltip title="Giữ lại website"><Button background green loading={plusLoading} leftIcon={Icon.plus} onClick={buttonHandlers.plus}></Button></Tooltip>}
			{(item.status === 2 && item.trash === 0) && <Tooltip title="Thử cài lại"><Button background blue loading={insertLoading} leftIcon={Icon.setting} onClick={buttonHandlers.reInsert}></Button></Tooltip>}
			{(item.trash === 0) && <Button key="edit" background blue leftIcon={Icon.edit} onClick={buttonHandlers.edit}></Button>}
			{(item.trash === 1) && <Button key="restore" background blue leftIcon={Icon.reload} onClick={buttonHandlers.restore}></Button>}
		</div>
	)
}

export default CreatedWebsiteAction;